module.exports = __webpack_public_path__ + "2899d5249025be0ba5457caa41953da6.svg";